import * as React from 'react';

import gql from 'graphql-tag';
import _ from 'lodash';

import CourseHeader from 'bundles/degree-home/components/course-section/CourseHeader';
import DueItem from 'bundles/degree-home/components/course-section/DueItem';
import type { DegreeCourse } from 'bundles/degree-home/types/Course';
import { getCourseLink } from 'bundles/degree-home/utils/Course';
import { getIsAssignmentPartForSplitPeer, getReviewPartFromSplitPeer } from 'bundles/degree-home/utils/ItemState';

import _t from 'i18n!nls/degree-home';

import 'css!./__styl__/Course';

type Props = {
  degreeId: string;
  course: DegreeCourse;
};

class Course extends React.Component<Props> {
  static fragment = gql`
    fragment DegreeCourseFragment on DegreeLearnerProgressesV1_courseMember {
      course {
        id
        name
        ...CourseLinkFragment
        itemStates {
          ...DueItemFragment
        }
      }
    }
    ${getCourseLink.fragment}
    ${DueItem.fragment}
  `;

  render() {
    const { course, degreeId } = this.props;
    const hasDueItems = course && course.itemStates && course.itemStates.length !== 0;
    const sortedItems = hasDueItems && _.sortBy(course.itemStates, (item) => item && item.deadline.dueAt);

    return (
      <li className="rc-Course bt3-row">
        <CourseHeader name={course.name} link={getCourseLink(course)} degreeId={degreeId} />

        <div className="horizontal-box align-items-bottom m-x-2 section-header">
          <span className="label-text color-secondary-text">{_t('Due')}</span>
        </div>

        {sortedItems &&
          sortedItems.map((item) => {
            if (getIsAssignmentPartForSplitPeer(item)) {
              return [
                <DueItem key={item.id} item={item} courseSlug={course.slug} />,
                <DueItem
                  key={`${item.id}ReviewPortion`}
                  // @ts-expect-error TSMIGRATION
                  item={getReviewPartFromSplitPeer(item)}
                  courseSlug={course.slug}
                />,
              ];
            }

            return <DueItem key={item.id} item={item} courseSlug={course.slug} />;
          })}

        {!hasDueItems && (
          <span className="no-due-items horizontal-box m-x-2">{_t('No assignments due this week')}</span>
        )}
      </li>
    );
  }
}

export default Course;
